import {santaSlider, Slider} from './Slider';
import {$skin as skin} from './Slider.st.css';

export default {
  componentType: 'wixui.Slider',
  component: Slider,
  santaComponent: santaSlider,
  skin
};
